import service from "@/utils/request";

export interface Sender {
  name: string
  avatar: string
  role_id: number
  role_type: string
}

export interface ChatMessage {
  sender: Sender
  content: string
}

export async function getChatHistory(record_id: number, node_id: number|undefined): Promise<{res: ChatMessage[]}> {
  let data = {}
  if (node_id != undefined){
    data = {node_id: node_id}
  }
  const res = await service.get(`/api/chat/history/${record_id}`, {params: data})
  return res.data
}

export async function sendChat(data: any): Promise<{ret:{ reply: string, sender: Sender, node_id: number}[], node_id: number, is_finished: boolean}> {
  const res = await service.post('/api/chat', data)
  return res.data
}